import React from 'react'
import classNames from 'classnames'

import './layout.scss'

export const Row: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = props => {
    const classnames = classNames(props.className, 'layout__row')

    return (
        <div {...props} className={classnames}>
            {props.children}
        </div>
    )
}

export const Column: React.FC<React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>> = props => {
    const classnames = classNames(props.className, 'layout__column')

    return (
        <div {...props} className={classnames}>
            {props.children}
        </div>
    )
}

export const Expaned: React.FC<React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>> = props => {
    const classnames = classNames(props.className, 'layout__expaned')

    return (
        <div {...props} className={classnames}>
            {props.children}
        </div>
    )
}

export const Center: React.FC<React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
>> = props => {
    const classnames = classNames(props.className, 'layout__center')

    return (
        <div {...props} className={classnames}>
            {props.children}
        </div>
    )
}

export const MainHeader = (props: any) => {
    return <div className="layout__main-header">{props.children}</div>
}
